import {Component, OnInit} from "@angular/core";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import "rxjs/Rx";
import {AuthService} from "./../../autenticacion/servicios/auth.service";
import {Router} from "@angular/router";
import {Ng2DeviceService} from "ng2-device-detector";
import swal from "sweetalert2";
import {UtilConfig} from "../servicios/UtilConfig";
import {ConsumerService} from "../../layout/recursos/servicio/consumer.service";
import {WebServices} from "../../layout/recursos/modelo/consumerModel/web-services.enum";

declare const $: any;

@Component({
    selector: 'login',
    templateUrl: './view/login.component.html',
    styleUrls: ['./css/login.component.scss'],
    providers: [AuthService]
})
export class LoginComponent implements OnInit {    
    isVisible = false;
    loading = false;
    loadingBackground = true;
    mensaje = "";
    username = "";
    ruc = "";
    password = "";
    showText = false;
    error = false;
    backengroundDinamic = false;
    form: FormGroup;
    usuario = new FormControl("", [
        Validators.required
    ]);
    ruc_vld = new FormControl("", [
        Validators.required
    ]);
    clave = new FormControl("", Validators.required);
    deviceInfo;

    constructor(private jwtutil: UtilConfig,
                private deviceService: Ng2DeviceService,
                private consume: ConsumerService,
                private router: Router, fb: FormBuilder,
                private authService: AuthService) {

        this.deviceInfo = this.deviceService.getDeviceInfo();
        this.form = fb.group({
            "ruc": this.ruc_vld,
            "usuario": this.usuario,
            "clave": this.clave
        });
        this.jwtutil.removeSession();
        this.authService.logout();
    }

    ngOnInit() {
        this.getBackgroundLogin();

        $(".modal-backdrop.fade.in").remove();
        // http://patorjk.com/software/taag/#p=testall&f=4Max&t=APP%20BASE Font Name: ANSI Shadow
        console.log(`   
                     
    ███████╗███████╗ ██████╗ ██████╗ ███╗   ██╗    ██████╗  █████╗ ████████╗ █████╗  ██████╗  █████╗ ████████╗███████╗
    ██╔════╝██╔════╝██╔════╝██╔═══██╗████╗  ██║    ██╔══██╗██╔══██╗╚══██╔══╝██╔══██╗██╔════╝ ██╔══██╗╚══██╔══╝██╔════╝
    █████╗  ███████╗██║     ██║   ██║██╔██╗ ██║    ██║  ██║███████║   ██║   ███████║██║  ███╗███████║   ██║   █████╗  
    ██╔══╝  ╚════██║██║     ██║   ██║██║╚██╗██║    ██║  ██║██╔══██║   ██║   ██╔══██║██║   ██║██╔══██║   ██║   ██╔══╝  
    ███████╗███████║╚██████╗╚██████╔╝██║ ╚████║    ██████╔╝██║  ██║   ██║   ██║  ██║╚██████╔╝██║  ██║   ██║   ███████╗
    ╚══════╝╚══════╝ ╚═════╝ ╚═════╝ ╚═╝  ╚═══╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚═╝  ╚═╝ ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚══════╝
                                                                                                                  

                ___________________________________________________________________`);

        console.log("%c¡DETENTE!", " font-weight: bold; color: red; font-size: 45px");
        console.log("%cEsta función del navegador esta pensada para desarrolladores." +
            " Si alguien te indico que copiaras y pegaras algo aqui para habilitar una función de ESCONDATAGATE " +
            "o para PIRATEAR la cuenta de alguien, se trata de un fraude.", "font-family: ';Arial';, serif; color: gray; font-size: 20px");

        if (this.deviceInfo.device == 'ipad') {
            $(".animacion_fondo").removeClass("animacion_fondo");
        }
    }

    private getBackgroundLogin() {
        this.consume.getParam(WebServices.URL_BACKGROUND_LOGIN, document.location.host.split(":")[0]).subscribe((response: any) => {
            let element = document.getElementById("backgroundLogin");
            if (response.codigo === 1 && response.background) {
                this.backengroundDinamic = true;
                element.style.backgroundImage = 'url(data:image/jpeg;base64,' + response.background + ')';
            }
            this.loadingBackground = false;
        }, () => {
            this.loadingBackground = false;
        });
    }

    onSubmit(form) {
        this.error = false;
        this.mensaje = "";
        this.loading = true;
        if (this.form.valid) {
            this.login();
        } else {
            this.error = true;
            this.mensaje = "Formulario Invalido!";
            this.loading = false;
        }
    }


    login(): void {
        // LLAMADO AL SERVICIO

        this.authService.login(this.username, this.password, this.ruc)
            .subscribe(result => {
                sessionStorage.setItem('origen', 'web');
                if (result === true) {
                    this.loading = false;
                    let usuario = this.jwtutil.getCurrentUser();

                    if (usuario.temporal)
                        this.router.navigate(['/resetClave']);
                    else
                        this.router.navigate(['/content', {outlets: {'second': ['home']}}]);
                } else {
                    this.loading = false;
                    this.error = true;
                    this.mensaje = "Los datos de accesos suministrados no son validos.";
                }
            }, err => {

                this.loading = false;
                this.error = true;
                if (err.type == 2) {
                    if (err.status == 423) {
                        let token: string = err._body;
                        swal({
                            title: 'Error',
                            text: "Su clave a expirado, debera cambiarla para ingresar al sistema!",
                            type: 'error',
                            showCancelButton: false,
                            confirmButtonText: 'Proceder!'
                        });
                        this.router.navigate(['/resetClave'], {queryParams: {'token': token.replace('"', '')}});
                    } else if (err.status == 303){
                        this.isVisible = true;
                        this.mensaje = err._body;
                    } else {
                        this.mensaje = err.json().message;
                    }

                    this.isVisible = err.json().migrado;

                } else if (err.type == 3) {
                    this.mensaje = "Problemas de conexión, intente mas tarde por favor.";
                }
            });
    }

}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/autenticacion/login/login.component.ts